import { appThemeColors, appThemeScrollbar } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import {
  appThemeRadius,
  appThemeSize,
  appThemeSpace,
} from "styles/appThemeTokens";
import { menuItemSx } from "../TopHeader.style";

export const customerButtonSx = {
  display: "flex",
  alignItems: "center",
  gap: appThemeSpace.sm,
  background: "none",
  border: 0,
  cursor: "pointer",
  color: appThemeColors.text.primary,
  fontFamily: appThemeFonts.family.ui,
  fontSize: appThemeFonts.size.base,
  height: appThemeSize.iconButton,
  padding: `0 ${appThemeSpace.md}`,
  borderRadius: appThemeRadius.md,
  minWidth: 0,
  textTransform: "none",
  "&:hover": {
    backgroundColor: appThemeColors.background.soft,
  },
};

export const customerIconSx = {
  width: 13,
  height: 13,
  color: appThemeColors.blue.dark,
};

export const buildingIconSx = {
  width: appThemeSize.menuChevron,
  height: appThemeSize.menuChevron,
  color: appThemeColors.blue.dark,
};

export const separatorDotSx = {
  color: appThemeColors.text.faint,
  lineHeight: appThemeFonts.lineHeight.tight,
};

export const customerNameSx = {
  fontWeight: appThemeFonts.weight.semibold,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: 180,
  color: appThemeColors.text.primary,
  fontSize: appThemeFonts.size.base,
};

export const chevronIconSx = {
  width: 13,
  height: 13,
  color: appThemeColors.text.faint,
  marginLeft: appThemeSpace.xxs,
};

export const customerMenuWidthSx = {
  width: appThemeSize.menuWidthMd,
};

export const customerMenuContainerSx = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "min(60vh, 320px)",
  overflow: "hidden",
  padding: `${appThemeSpace.md} ${appThemeSpace.md} 0`,
};

export const customerMenuItemsScrollSx = {
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  margin: `0 -${appThemeSpace.md}`,
  padding: `0 ${appThemeSpace.md} ${appThemeSpace.md}`,
  ...appThemeScrollbar,
};

export const customerMenuItemSx = {
  ...menuItemSx,
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "1px",
};

export const customerMenuNameSx = {
  fontFamily: appThemeFonts.family.ui,
  fontWeight: appThemeFonts.weight.medium,
  fontSize: appThemeFonts.size.base,
  color: appThemeColors.text.primary,
  lineHeight: appThemeFonts.lineHeight.snug,
};

export const customerMenuSubSx = {
  fontFamily: appThemeFonts.family.ui,
  fontSize: appThemeFonts.size.smPlus,
  color: appThemeColors.text.faint,
  lineHeight: appThemeFonts.lineHeight.snug,
};
